"use strict";
/**
 * @ignore
 */

/** */

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.createAqiFromBreakpoints = exports.round = void 0;

var debug_1 = __importDefault(require("debug"));

var l = debug_1["default"]('shootismoke:convert');
/**
 * Round a number to closest 10^-{decimal}
 *
 * @param n - The float number to round
 * @param decimal - The number of decimals after the .
 */

function round(n, decimals) {
  if (decimals === void 0) {
    decimals = 0;
  }

  return Math.round(Math.pow(10, decimals) * n) / Math.pow(10, decimals);
}

exports.round = round;
/**
 * From the breakpoints, we can derive the range (i.e. [min,max]) values of the
 * AQI.
 *
 * @param breakpoints - The breakpoints to calculate the range from
 */

function getRange(breakpoints) {
  return [breakpoints[0][0], breakpoints[breakpoints.length - 1][1]];
}
/**
 * Convert an AQI to raw concentration using breakpoints
 *
 * @param value - AQI value to convert
 * @param breakpoints - Breakpoints defining the AQI
 */


function _toRaw(aqiPiecewise, rawPiecewise, value) {
  // Find the segment in which the `aqi` is
  var segment = aqiPiecewise.findIndex(function (_a) {
    var _b = __read(_a, 2),
        aqiLow = _b[0],
        aqiHigh = _b[1];

    return aqiLow <= value && value <= aqiHigh;
  });

  if (segment === -1) {
    // For PM2.5 greater than 500, AQI is not officially defined, but since
    // such levels have been occurring throughout China in recent years, one of
    // two conventions is used. Either the AQI is defined as equal to PM2.5 (in
    // micrograms per cubic meter) or the AQI is simply set at 500.
    // We take the 1st convention here.
    // We also do the same for other pollutants
    return value;
  }

  var _a = __read(aqiPiecewise[segment], 2),
      aqiLow = _a[0],
      aqiHigh = _a[1];

  var _b = __read(rawPiecewise[segment], 2),
      rawLow = _b[0],
      rawHigh = _b[1]; // Round to closest 0.1


  return round((value - aqiLow) / (aqiHigh - aqiLow) * (rawHigh - rawLow) + rawLow, 1);
}
/**
 * Convert raw concentration to AQI using breakpoints
 *
 * @param raw - The raw value to convert
 * @param breakpoints - Breakpoints defining the AQI
 */


function _fromRaw(aqiPiecewise, rawPiecewise, raw) {
  // Find the segment in which the `aqi` is
  var segment = rawPiecewise.findIndex(function (_a) {
    var _b = __read(_a, 2),
        rawLow = _b[0],
        rawHigh = _b[1];

    return rawLow <= raw && raw <= rawHigh;
  });

  if (segment === -1) {
    // For PM2.5 greater than 500, AQI is not officially defined, but since
    // such levels have been occurring throughout China in recent years, one of
    // two conventions is used. Either the AQI is defined as equal to PM2.5 (in
    // micrograms per cubic meter) or the AQI is simply set at 500.
    // We take the 1st convention here.
    // We also do the same for other pollutants
    return raw;
  }

  var _a = __read(aqiPiecewise[segment], 2),
      aqiLow = _a[0],
      aqiHigh = _a[1];

  var _b = __read(rawPiecewise[segment], 2),
      rawLow = _b[0],
      rawHigh = _b[1]; // Round to closest integer


  return round((aqiHigh - aqiLow) / (rawHigh - rawLow) * (raw - rawLow) + aqiLow);
}

function assertTracked(aqiCode, pollutant, breakpoints) {
  if (!breakpoints.aqi) {
    l(aqiCode + " does not have AQI breakpoints");
    throw new Error(aqiCode + " does not have AQI breakpoints");
  }

  if (!breakpoints[pollutant]) {
    l(aqiCode + " does not apply to pollutant " + pollutant);
    throw new Error(aqiCode + " does not apply to pollutant " + pollutant);
  }
}
/**
 * Create an AQI from its breakpoints
 *
 * @param aqiCode - The code of the AQI
 * @param breakpoints - The breakpoints defining the AQI
 */


function createAqiFromBreakpoints(aqiCode, breakpoints) {
  return {
    pollutants: Object.keys(breakpoints),
    fromRaw: function fromRaw(pollutant, raw) {
      assertTracked(aqiCode, pollutant, breakpoints);
      return _fromRaw(breakpoints.aqi, breakpoints[pollutant], raw);
    },
    range: getRange(breakpoints.aqi),
    toRaw: function toRaw(pollutant, value) {
      assertTracked(aqiCode, pollutant, breakpoints);
      return _toRaw(breakpoints.aqi, breakpoints[pollutant], value);
    }
  };
}

exports.createAqiFromBreakpoints = createAqiFromBreakpoints;